/**
 * Panel Reveal Module
 * Handles fade-in animations for story panels
 * Note: Uses IIFE pattern for Ghost's concatenated build system
 */

(function (window) {
  'use strict';

  class PanelReveal {
    constructor(core) {
      this.core = core;
      this.panels = [];

      this.init();
    }

    init() {
      if (!this.core.root) return;

      // Find all panels with reveal class
      this.panels = Array.from(
        this.core.root.querySelectorAll('.story-panel[data-reveal]')
      );

      if (this.panels.length === 0) {
        return;
      }

      // If reduced motion, skip animation and show all panels
      if (this.core.hasReducedMotion) {
        this.panels.forEach(function(panel) {
          panel.classList.add('is-visible');
        });
        return;
      }

      // Setup reveal listeners for each panel
      this.setupPanelListeners();

      // Observe all panels
      this.core.observe(this.panels, 'reveal');

      // Register with core
      this.core.registerModule('panelReveal', this);
    }

    setupPanelListeners() {
      var self = this;
      this.panels.forEach(function(panel) {
        panel.addEventListener('story:reveal:enter', function() {
          self.revealPanel(panel);
        });
      });
    }

    revealPanel(panel) {
      // Add visible class to trigger CSS transition
      panel.classList.add('is-visible');

      // Optional: Unobserve after reveal (one-time animation)
      // Uncomment if you want panels to stay revealed
      // this.core.unobserve([panel], 'reveal');
    }

    destroy() {
      var self = this;
      this.panels.forEach(function(panel) {
        self.core.unobserve([panel], 'reveal');
      });
      this.panels = [];
    }
  }

  // Expose PanelReveal to window for other modules
  window.StoryModulePanelReveal = PanelReveal;

})(window);
